import React from 'react';
import Box from '@material-ui/core/Box';

interface Props {
  my?: any;
  mt?: any;
}

const BoxWrapper: React.FC<Props> = ({ my, mt, children }) => (
  <Box my={my} mt={mt}>
    {children}
  </Box>
);

BoxWrapper.defaultProps = {
  my: 0,
  mt: 0,
};

export default BoxWrapper;
